const publicLayout = {
  nav: {
    about: "Um kerfið",
    security: "Öryggi",
    roadmap: "Vegvísir",
  },
  adminNav: {
    overview: "Yfirlit",
    users: "Notendur",
    projects: "Verkefni",
    dataRequests: "Beiðnir til afgreiðslu",
    datasets: "Gagnasöfn",
  },
  brand: {
    tagline: "Dulnefningarþjónusta",
  },
  header: {
    dashboard: "Stjórnborð",
    login: "Skrá inn",
  },
  footer: {
    marketing: {
      description:
        "Dulnefningarþjónusta fyrir heilbrigðisrannsóknir: rannsakendur fá gögnin, enginn fær auðkennin. Byggt fyrir háskóladeildir, stofnanir og rannsóknareiningar — og fyrir sjúkrahúsin, heilbrigðisskrár og aðra sem leggja þeim til gögn.",
      readHeading: "Lesefni",
      accessHeading: "Aðgangur",
      invitationOnly: "Aðgangur er eingöngu veittur með boði.",
      dayToDayQuestions:
        "Spurningar í daglegu amstri: verkefnisstjórinn þinn, eða deildarstjórinn þinn.",
      contactBefore: "Tillögur, villutilkynningar, ný deild:",
      inDevelopment: {
        before: "Í virkri þróun — Sjá",
        roadmapLink: "vegvísinn",
        after: "fyrir núverandi stöðu.",
      },
      technicalControlNote:
        "Dulnefning er tæknileg vörn, ekki staðgengill fyrir siðanefndarleyfi.",
    },
    app: {
      title: "Dulnefningarþjónusta",
      subtitle: "Örugg, samhengisháð dulnefning rannsóknargagna",
      about: "Um kerfið og leiðbeiningar",
      security: "Öryggi",
      roadmap: "Vegvísir",
    },
  },
};

export default publicLayout;
